import api from '@/api';
import { safeGetItem, safeSetItem } from '@/utils/storage';

const state = {
  token: localStorage.getItem('organizer_token') || '',
  userInfo: safeGetItem('organizer_user_info', null),
  permissions: []
};

const getters = {
  token: state => state.token,
  userInfo: state => state.userInfo,
  isLoggedIn: state => !!state.token, // 只检查token是否存在，不验证有效性
  permissions: state => state.permissions,
  hasPermission: state => permission => state.permissions.includes(permission)
};

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token;
    if (token) {
      localStorage.setItem('organizer_token', token);
    } else {
      localStorage.removeItem('organizer_token');
    }
  },
  
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
    safeSetItem('organizer_user_info', userInfo);
  },
  
  SET_PERMISSIONS(state, permissions) {
    state.permissions = permissions;
  },
  
  CLEAR_USER_DATA(state) {
    state.token = '';
    state.userInfo = {};
    state.permissions = [];
    localStorage.removeItem('organizer_token');
    localStorage.removeItem('organizer_user_info');
  }
};

const actions = {
  // 登录
  async login({ commit }, loginForm) {
    try {
      const response = await api.user.login(loginForm);
      const { token, user, permissions } = response.data;
      
      commit('SET_TOKEN', token);
      commit('SET_USER_INFO', user);
      commit('SET_PERMISSIONS', permissions || []);
      
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 检查登录状态
  async checkLogin({ commit, state }) {
    if (!state.token) {
      throw new Error('未登录');
    }
    
    try {
      const response = await api.user.getUserInfo();
      const { user, permissions } = response.data;
      
      commit('SET_USER_INFO', user);
      commit('SET_PERMISSIONS', permissions || []);
      
      return response;
    } catch (error) {
      commit('CLEAR_USER_DATA');
      throw error;
    }
  },
  
  // 登出
  async logout({ commit }) {
    try {
      await api.user.logout();
    } catch (error) {
      console.error('登出接口调用失败:', error);
    } finally {
      commit('CLEAR_USER_DATA');
    }
  },
  
  // 更新用户信息
  async updateUserInfo({ commit }, userInfo) {
    try {
      const response = await api.user.updateUserInfo(userInfo);
      commit('SET_USER_INFO', response.data);
      return response;
    } catch (error) {
      throw error;
    }
  },
  
  // 修改密码
  async changePassword({ commit }, passwordData) {
    try {
      const response = await api.user.changePassword({
        old_password: passwordData.oldPassword,
        new_password: passwordData.newPassword,
        confirm_password: passwordData.confirmPassword
      });
      return response;
    } catch (error) {
      throw error;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
